<template>
  <v-container fluid fill-height align-stretch>
    <v-row no-gutters class="pa-1">
      <v-col cols="12" sm="12" lg="12">
        <i-card-vertical headerTitle="color">
          <template v-slot:body>
            <v-row>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="primary">
                    <div class="content--text py-3">{{ primary }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">primary</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="secondary">
                    <div class="content--text py-3">{{ secondary }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">secondary</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="third">
                    <div class="content--text py-3">{{ third }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">third</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="accent">
                    <div class="content--text py-3">{{ accent }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">accent</v-layout>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="pb-4">
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="error">
                    <div class="content--text py-3">{{ error }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">error</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="success">
                    <div class="content--text py-3">{{ success }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">success</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="warning">
                    <div class="content--text py-3">{{ warning }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">warning</v-layout>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="app_bar_title">
                    <div class="content--text py-3">{{ app_bar_title }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">app_bar_title</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="nav_title">
                    <div class="content--text py-3">{{ nav_title }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">nav_title</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="menu_title">
                    <div class="content--text py-3">{{ menu_title }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">menu_title</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="list_title">
                    <div class="content--text py-3">{{ list_title }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">list_title</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="card_title">
                    <div class="content--text py-3">{{ card_title }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">card_title</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="sub_title">
                    <div class="content--text py-3">{{ sub_title }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">sub_title</v-layout>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="pb-4">
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="content">
                    <div class="content--text py-3">{{ content }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">content</v-layout>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="app_bar_bg">
                    <div class="content--text py-3">{{ app_bar_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">app_bar_bg</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="nav_bg">
                    <div class="content--text py-3">{{ nav_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">nav_bg</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="menu_bg">
                    <div class="content--text py-3">{{ menu_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">menu_bg</v-layout>
                </v-card>
              </v-col>
              <!-- //tabviewbg //2022-03-17 by lyj tabview테마적용 start2 -->
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="tabview_bg">
                    <div class="content--text py-3">{{ tabview_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">tabview_bg</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="tabview_active_text">
                    <div class="content--text py-3">{{ tabview_active_text }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">tabview_active_text</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="tabview_text">
                    <div class="content--text py-3">{{ tabview_text }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">tabview_text</v-layout>
                </v-card>
              </v-col>
              <!-- //tabviewbg //2022-03-17 by lyj tabview테마적용 end -->
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="list_bg">
                    <div class="content--text py-3">{{ list_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">list_bg</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="container_bg">
                    <div class="content--text py-3">{{ container_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">container_bg</v-layout>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="card_bg">
                    <div class="content--text py-3">{{ card_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">card_bg</v-layout>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" lg="2" class="pa-1">
                <v-card elevation="3" class="pa-1">
                  <v-card class="text-center py-2" :color="card_title_bg">
                    <div class="content--text py-3">{{ card_title_bg }}</div>
                  </v-card>
                  <v-layout justify-end class="font-weight-bold">card_title_bg</v-layout>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
export default {
  name: 'colorTab',
  components: {
    'i-card-vertical': iCardVertical
  },
  computed: {
    primary: function() {
      return this.$vuetify.theme.themes.light.primary
    },
    secondary: function() {
      return this.$vuetify.theme.themes.light.secondary
    },
    third: function() {
      return this.$vuetify.theme.themes.light.third
    },
    accent: function() {
      return this.$vuetify.theme.themes.light.accent
    },
    error: function() {
      return this.$vuetify.theme.themes.light.error
    },
    success: function() {
      return this.$vuetify.theme.themes.light.success
    },
    warning: function() {
      return this.$vuetify.theme.themes.light.warning
    },
    app_bar_title: function() {
      return this.$vuetify.theme.themes.light.app_bar_title
    },
    nav_title: function() {
      return this.$vuetify.theme.themes.light.nav_title
    },
    menu_title: function() {
      return this.$vuetify.theme.themes.light.menu_title
    },
    list_title: function() {
      return this.$vuetify.theme.themes.light.list_title
    },
    card_title: function() {
      return this.$vuetify.theme.themes.light.card_title
    },
    sub_title: function() {
      return this.$vuetify.theme.themes.light.sub_title
    },
    content: function() {
      return this.$vuetify.theme.themes.light.content
    },
    app_bar_bg: function() {
      return this.$vuetify.theme.themes.light.app_bar_bg
    },
    nav_bg: function() {
      return this.$vuetify.theme.themes.light.nav_bg
    },
    menu_bg: function() {
      return this.$vuetify.theme.themes.light.menu_bg
    },
    //2022-03-17 by lyj tabview테마적용 start
    tabview_bg: function() {
      return this.$vuetify.theme.themes.light.tabview_bg
    },
    tabview_active_text: function() {
      return this.$vuetify.theme.themes.light.tabview_active_text
    },
    tabview_text: function() {
      return this.$vuetify.theme.themes.light.tabview_text
    },
    //2022-03-17 by lyj tabview테마적용 end
    list_bg: function() {
      return this.$vuetify.theme.themes.light.list_bg
    },
    container_bg: function() {
      return this.$vuetify.theme.themes.light.container_bg
    },
    card_bg: function() {
      return this.$vuetify.theme.themes.light.card_bg
    },
    card_title_bg: function() {
      return this.$vuetify.theme.themes.light.card_title_bg
    }
  }
}
</script>
